<template>
	<component :is="formModule.component" @hide="back" />
</template>
<style>

</style>
<script>
	
	export default {
		props: {
			name: {
				type: String,
				default: () => {
					return ''
				}
			}

		},
		data() {
			return {
				loading:false,
				model: false,
				formModule:{
					component:''
				}
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.init()
		},

		methods: {
			init() {
				import(`./${this.name}/index.vue`).then((res) => {
					this.formModule = {
						component: res.default,
					}
					this.model = true
				})
			
			},
			show(){
				
			},
			hide(){
				
			},
			back(){
				this.$emit('back')
			}
		},
		components: {
					
		}
	}
</script>
